import { FadeUp, MonoLabel } from "@/components/Reveal";

const logos = [
  { src: "/logos/geeks.jpeg", name: "Geeks" },
  { src: "/logos/merkle.png", name: "Merkle" },
  { src: "/logos/plivo.png", name: "Plivo" },
  { src: "/logos/tripgain.png", name: "TripGain" },
  { src: "/logos/zylo.png", name: "Zyte" },
];

function LogoStrip({ suffix }) {
  return (
    <div className="flex shrink-0 items-center gap-5 pr-5">
      {logos.map((logo) => (
        <div
          key={logo.name}
          className="group flex items-center justify-center w-48 h-24 sm:w-56 sm:h-28 rounded-2xl border border-black/10 bg-white p-6 shrink-0"
          data-testid={`logo-${logo.name.toLowerCase()}-${suffix}`}
        >
          <img
            src={logo.src}
            alt={`${logo.name} logo`}
            className="max-h-full max-w-full object-contain grayscale group-hover:grayscale-0 transition-[filter] duration-500"
          />
        </div>
      ))}
    </div>
  );
}

export default function LogoWall() {
  return (
    <section className="border-b border-black/10 py-12 sm:py-16 overflow-hidden" data-testid="logo-wall">
      <FadeUp className="px-6 sm:px-12 mb-10">
        <MonoLabel>Some brands I've worked with</MonoLabel>
      </FadeUp>
      <div className="relative select-none">
        <div className="animate-marquee flex w-max">
          <LogoStrip suffix="a" />
          <LogoStrip suffix="b" />
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      </div>
    </section>
  );
}
